<div class="detail-container">
  <p-toast />

  <!-- Barra superior -->
  <div class="topbar">
    <button
      pButton
      type="button"
      icon="pi pi-arrow-left"
      label="Volver"
      severity="secondary"
      size="small"
      (click)="goBack()"
    ></button>
    <h1>Detalle de la carrera</h1>
  </div>

  @if (loading) {
    <div class="state-msg">Cargando detalle…</div>
  } @else if (!trip) {
    <div class="state-msg">No se encontró información de la carrera.</div>
  } @else {
    <!-- Cabecera premium -->
    <div class="hero">
      <div class="hero-left">
        <span class="hero-date">{{ trip.car_tri_date | date: 'dd MMM yyyy, HH:mm' }}</span>
        <span class="hero-code-label">Código de carrera</span>
        <div class="hero-code-row">
          <span class="hero-code">{{ trip.car_tri_id_trip }}</span>
          <button
            pButton
            type="button"
            icon="pi pi-copy"
            label="Copiar"
            size="small"
            severity="secondary"
            class="copy-btn"
            title="Copiar código"
            (click)="copyCode()"
          ></button>
        </div>
      </div>
      <div class="hero-right">
        <span class="status-badge big" [ngClass]="statusClass()">
          {{ trip.st_name || 'Sin estado' }}
        </span>
      </div>
    </div>

    <!-- Métricas del viaje -->
    <div class="metrics">
      <div class="metric">
        <span class="metric-icon">📏</span>
        <div>
          <span class="metric-label">Distancia</span>
          <span class="metric-value">{{ distanceMiles }} mi</span>
        </div>
      </div>
      <div class="metric">
        <span class="metric-icon">💵</span>
        <div>
          <span class="metric-label">Precio</span>
          <span class="metric-value price">${{ trip.car_tri_price | number: '1.2-2' }}</span>
        </div>
      </div>
      <div class="metric">
        <span class="metric-icon">⏱️</span>
        <div>
          <span class="metric-label">Tiempo de llegada</span>
          <span class="metric-value">{{ trip.car_tri_time_wait ?? 0 }} min</span>
        </div>
      </div>
      <div class="metric">
        <span class="metric-icon">🚗</span>
        <div>
          <span class="metric-label">Placa</span>
          <span class="metric-value">{{ trip.car_tri_plate || '—' }}</span>
        </div>
      </div>
    </div>

    <!-- Cliente + Conductor -->
    <div class="cards-grid">
      <div class="card">
        <h3>👤 Cliente</h3>
        <p><strong>Nombre</strong><span>{{ trip.usr_name }} {{ trip.usr_last_name }}</span></p>
        <p><strong>Teléfono</strong><span>{{ trip.usr_phone || '—' }}</span></p>
      </div>

      <div class="card driver-card">
        <h3>🚕 Conductor</h3>
        <div class="driver-head">
          <div class="avatar-ring">
            @if (trip.dri_url_photo) {
              <img [src]="trip.dri_url_photo" alt="Conductor" class="avatar-img" />
            } @else {
              <div class="avatar-placeholder"><i class="pi pi-user"></i></div>
            }
          </div>
          <div class="driver-info">
            <span class="driver-name">{{ trip.dri_name || 'Sin asignar' }} {{ trip.dri_last_name }}</span>
            <span class="driver-phone">{{ trip.dri_phone || '—' }}</span>
            @if (trip.com_name) {
              <span class="driver-company"><i class="pi pi-building"></i> {{ trip.com_name }}</span>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Direcciones -->
    <div class="cards-grid">
      <div class="card address origin">
        <h3>📍 Origen</h3>
        <p class="addr-name">{{ trip.add_name_origin || '—' }}</p>
        @if (trip.add_reference_origin) {
          <p class="addr-ref">{{ trip.add_reference_origin }}</p>
        }
      </div>
      <div class="card address destino">
        <h3>🎯 Destino</h3>
        <p class="addr-name">{{ trip.add_name_destination || '—' }}</p>
        @if (trip.add_reference_destination) {
          <p class="addr-ref">{{ trip.add_reference_destination }}</p>
        }
      </div>
    </div>

    <!-- Mapa -->
    <div class="card map-card">
      <div class="map-head">
        <h3>🗺️ Recorrido</h3>
        <div class="legend">
          <span class="legend-item"><span class="dot origin"></span>Origen</span>
          <span class="legend-item"><span class="dot destino"></span>Destino</span>
        </div>
      </div>
      <google-map
        [center]="mapCenter"
        [zoom]="mapZoom"
        [options]="mapOptions"
        width="100%"
        height="460px"
        class="map"
        (mapInitialized)="onMapReady($event)"
      />
    </div>

    <!-- Calificaciones -->
    <div class="cards-grid">
      <div class="card score-card">
        <h3>⭐ Calificación del conductor</h3>
        @if (trip.driver_score) {
          <div class="score">
            <span class="score-value">{{ trip.driver_score.sco_scoore }} / 5</span>
            <span class="score-date">{{ trip.driver_score.sco_date | date: 'dd-MM-yyyy HH:mm' }}</span>
          </div>
          <p class="score-comment">
            {{ trip.driver_score.sco_comment || 'Sin comentario' }}
          </p>
        } @else {
          <p class="no-score">Sin calificación</p>
        }
      </div>
      <div class="card score-card">
        <h3>⭐ Calificación del cliente</h3>
        @if (trip.client_score) {
          <div class="score">
            <span class="score-value">{{ trip.client_score.sco_scoore }} / 5</span>
            <span class="score-date">{{ trip.client_score.sco_date | date: 'dd-MM-yyyy HH:mm' }}</span>
          </div>
          <p class="score-comment">
            {{ trip.client_score.sco_comment || 'Sin comentario' }}
          </p>
        } @else {
          <p class="no-score">Sin calificación</p>
        }
      </div>
    </div>
  }
</div>
